import { OPTION_OTHER } from '@/utils/demographicDataMappers';
import RadioButton, { TRadioButtonFontSize } from './RadioButton';
import { Flex, HStack } from '@chakra-ui/react';
import { CSSProperties, Fragment } from 'react';
import { background } from '@/theme/colors/palettes';

const RadioButtonGroup = ({
  items,
  selectedItem,
  onClick,
  textInputValue,
  setTextInputValue,
  containerStyle,
  width,
  noOfLines = 1,
  fontSize = 'sm',
  vertical = false,
  borderWidth = 2,
  disabled = false,
  separatorLineAfterIndex,
}: {
  items: string[];
  selectedItem: string;
  onClick: (_: string) => void;
  textInputValue?: string;
  setTextInputValue?: (_: string) => void;
  containerStyle?: CSSProperties;
  width?: number | string;
  noOfLines?: number;
  fontSize?: TRadioButtonFontSize;
  vertical?: boolean;
  borderWidth?: number;
  disabled?: boolean;
  separatorLineAfterIndex?: number;
}) => {
  return (
    <Flex gap={5} flexWrap={'wrap'} flexDirection={vertical ? 'column' : 'row'} style={containerStyle}>
      {items.map((item, i) => (
        <Fragment key={item}>
          <RadioButton
            key={item}
            label={item}
            isSelected={selectedItem === item}
            hasTextInput={item === OPTION_OTHER && selectedItem === item}
            textInputValue={textInputValue}
            setTextInputValue={setTextInputValue}
            onClick={() => onClick(item)}
            fontSize={fontSize}
            noOfLines={noOfLines}
            borderWidth={borderWidth}
            width={width}
            disabled={disabled}
          />
          {separatorLineAfterIndex && separatorLineAfterIndex === i && (
            <HStack width={'100%'} height={'1px'} backgroundColor={background.separatorBlue} />
          )}
        </Fragment>
      ))}
    </Flex>
  );
};

export default RadioButtonGroup;
